import { SignalRProvider } from 'brokertslib/src/context/SignalRProvider'
import { useContext, useState } from 'react'

import { SendCalculationModal, SendCalculationTravelContextProvider } from '@/containers/SendCalculationModal'
import { SortBy } from '@/context/OffersProvider'

import { Container } from '../../../components/Container'
import { Loading } from '../../../components/Loading'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { InsuranceInfo } from '../../../containers/InsuranceInfo'
import { OfferCestovkoCompare } from '../../../containers/offers/OfferCestovkoCompare'
import { CestovkoOffersProvider } from '../../../context/CestovkoOffersProvider'
import { StepsContent } from '../../../context/StepsContext'
import { insuranceParamsContext } from '../../../layouts/Wizard'

const baseUrl = import.meta.env.VITE_BASE_URL
const hubUrl = import.meta.env.VITE_CALCULATION_HUB
const url = `${baseUrl}/${hubUrl}`

export const Step3 = () => {
  const { insuranceParams, insuranceParamsId: paramsId, isLoadingData } = useContext(insuranceParamsContext)

  const [order, setOrder] = useState(1)
  const setOrderFunc = (order: SortBy) => {
    switch (order) {
      case SortBy.Insurer:
        setOrder(3)
        break

      default:
        setOrder(1)
        break
    }
  }

  return (
    <Section>
      <Container>
        {isLoadingData && <Loading large={true} />}

        {(!paramsId || insuranceParams) && !isLoadingData &&
          <StepsContent step={3}>
            <SignalRProvider url={url}>
              <CestovkoOffersProvider>
                <Steps icon="beach" />

                <SendCalculationTravelContextProvider order={order}>
                  <SendCalculationModal />
                  <InsuranceInfo />
                </SendCalculationTravelContextProvider>

                <OfferCestovkoCompare setOrderFunc={setOrderFunc} />
              </CestovkoOffersProvider>
            </SignalRProvider>
          </StepsContent>
        }

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}
